export class Region {
    Continents!: string[]
    Name!: string
    FriendlyName!: string
    Prefix!: string
    Hostnames!: string[]
}

export class MultiRegionConfiguration {
    Regions!: Region[]
}
